// extracted by mini-css-extract-plugin
export var dropdown = "_uu-0";
export var imageWrapper = "_uu-3";
export var itemNameContainer = "_uu-1";
export var productImage = "_uu-2";
export var spinnerWrapper = "_uu-4";